import Model from 'src/storage/base';

class AuthModel extends Model {
  id = 'auth';
  persistent = false;

  apiConfig = {
    password: {
      url: 'admin/auth/password',
      validation: {
        username: 'emailAddress',
        password: 'password'
      },
      cancellable: true
    }
  };

  loginPassword = () => {
    let req = {
      username: this.state.username,
      password: this.state.password
    };
    this.api('password', req, this.onLogin);
  };

  onLogin = (error, data, success) => {
    if (success) {
      this.emit('auth', data);
    }
  };
}

const model = new AuthModel();
export default model;
